export default {
  bookinginputfield: {
    default: 'Référence de réservation | Références de réservation',
    list: {
      page_title: 'Liste des références de réservation'
    },
    edit: {
      page_title: 'Modification de la référence '
    },
    show: {
      page_title: 'Référence'
    },
    create: {
      page_title: "Création d'une référence de réservation"
    },
    type: {
      10: 'Numérique',
      20: 'Texte',
      21: 'Email',
      22: 'Téléphone',
      30: 'Menu déroulant',
      40: 'Booléen',
      50: 'Paragraphe'
    }
  }
}
